import WarningModal from './warning-modal';

export default WarningModal;
